import { jsx } from 'react/jsx-runtime';
import { Heading } from '../Heading/Heading.es.js';
import '../../../utils/heading-level-context/HeadingLevelContext.es.js';

const tableTitleArea = "_table-title-area_10lid_1";
const title = "_title_10lid_10";
const styles = {
	tableTitleArea: tableTitleArea,
	title: title
};

const TableTitle = (props) => {
  return jsx(Heading, { className: styles.title, children: props.children });
};
const TableTitleArea = ({ children, kind = "standard" }) => {
  return jsx("header", { className: styles.tableTitleArea, "data-kind": kind, "data-zds": true, children });
};

export { TableTitle, TableTitleArea };
//# sourceMappingURL=TableTitleArea.es.js.map
